import React from 'react';
import { RequireNewPassword as AWSRequireNewPassword } from 'aws-amplify-react';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import AppLogo from 'components/theme/app-logo';
import { Typography } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    height: '100vh'
  },
  main: {
    maxWidth: 400,
    marginTop: -100
  },
  title: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  action: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 2
  }
});

function convertToPlaceholder(str) {
  return str
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.substr(1).toLowerCase())
    .join(' ');
}

class RequireNewPassword extends AWSRequireNewPassword {
  showComponent() {
    const { classes } = this.props;

    const user = this.props.authData;

    const { requiredAttributes } = user.challengeParam;
    return (
      <>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="center"
          className={classes.root}
        >
          <Grid item xs={10} sm={5} className={classes.main}>
            <AppLogo />
            <Typography
              variant="h6"
              headlineMapping={{ h6: 'h1' }}
              className={classes.title}
            >
              Change Password
            </Typography>
            <TextField
              autoFocus
              required
              label="Password"
              key="password"
              name="password"
              type="password"
              placeholder="New Password"
              margin="normal"
              onChange={this.handleInputChange}
              autoComplete="new-password"
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />

            {requiredAttributes.map((attribute) => (
              <TextField
                label={attribute}
                key={attribute}
                name={attribute}
                type="text"
                placeholder={convertToPlaceholder(attribute)}
                autoComplete={`new-${attribute}`}
                margin="normal"
                onChange={this.handleInputChange}
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            ))}

            <Button
              variant="contained"
              color="primary"
              name="btn-change-password"
              onClick={this.change}
              className={classes.action}
            >
              Change
            </Button>
            <Button
              size="small"
              color="primary"
              onClick={() => this.changeState('signIn')}
              variant="text"
              name="btn-back-to-sign-in"
              className={classes.action}
            >
              Back to Sign In
            </Button>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(RequireNewPassword);
